<template>
    <div :class="getCSSClass('document-previewer-container')" style="position: relative; min-height: 70vh; height: 100%;">
        <button v-on:click="$emit('close')"  v-html="'&times;'"
                :class="getCSSClass('document-previewer-close-button')"></button>
        <div v-show="loading" v-html="loadingIndicator" style="display: flex; justify-content: center; padding-top: .5rem; width: 100%; position: absolute; height: 2.5rem; top: 0; left: 0; z-index: 10; "></div>
        <component :is="viewers[type]"
                   :url="url"
                   :type="type"
                   :file="file"
                   v-on:loadingflag="setLoading"
                   v-on:close="$emit('close')"
        ></component>
    </div>
</template>

<script>

export default {
    inject: ['loadingIndicator', 'getCSSClass', 'translate', 'icon'],
    props: {
        url: {type: String},
        type: {type: String},
        file: {type: Object},
        viewers: {type: Object, default: () => {
            return {
                'application/pdf': 'PDFViewerComponent',
            }
        }}
    },
    data: function () {
        return {
            loading: true,
        }
    },
    mounted() {
    },
    methods: {
        setLoading: function(payload) {
            this.loading = payload;
        }
    },
    computed: {},
    watch: {}

}
</script>
<style>

</style>
